import {ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild} from '@angular/core';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';
import {TreeNode} from 'primeng/api';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {TaskDetailsComponent} from '../../task/task-details/task-details.component';
import {TaskChatComponent} from '../../task/task-chat/task-chat.component';
import {TaskInstructions} from '../../task/task-instructions/task-instructions.component';
import {SdkImportsModule} from '../../../../../sdk/src/sdk-imports';
import {CommonModule} from '@angular/common';
import {TaskTreeViewExtension} from '../../../api-extensions/views/task-tree.view-extension';
import {takeUntil} from 'rxjs/operators';
import {TaskCRUDComponent} from '../../task/task-crud/task-crud.component';

/**
 * Service Request Tasks Component
 * Displays tasks with side panel (details, chat, instructions)
 */
@Component({
    selector: 'app-service-request-tasks',
    templateUrl: './service-request-tasks.component.html',
    styleUrl: './service-request-tasks.component.scss',
    imports: [
        CommonModule,
        PrimeNgImportsModule,
        SdkImportsModule,
        TaskCRUDComponent,
        TaskDetailsComponent,
        TaskChatComponent,
        TaskInstructions
    ]
})
export class ServiceRequestTasksComponent extends IBasePageComponent {
    @ViewChild(TaskCRUDComponent, {static: true})
    protected _taskCrud?: TaskCRUDComponent;
    @ViewChild(TaskDetailsComponent, {static: true})
    protected _taskDetails?: TaskDetailsComponent;

    // ===============================================================
    // ===============================================================

    protected _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    protected _sidePanelVisible: boolean[] = [true, false];
    protected _selectedTask: TreeNode<TaskTreeViewExtension> | null = null;
    protected _tasksTreeItems: TaskTreeViewExtension[] | null = null;

    // ===============================================================
    // ===============================================================

    /**
     * Event emitter to notify parent when tasks are created, updated, or deleted
     */
    @Output() taskChanged = new EventEmitter<void>();

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        // Subscribe to task CRUD events to trigger statistics refresh
        if (this._taskCrud) {
            this._taskCrud.onModalResult.pipe(takeUntil(this._destroy$)).subscribe(() => {
                this.taskChanged.emit();
            });

            this._taskCrud.onDeleteResult.pipe(takeUntil(this._destroy$)).subscribe(() => {
                this.taskChanged.emit();
            });
        }
    }

    /**
     * On destroy (Error handling is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * A task has been selected from the details panel
     */
    protected selectTask(taskUuid: string) {
        this._taskCrud?.onTaskSelectedFromDetails(taskUuid);
    }
}
